import { styled } from 'parkdepot-shared/theme'

export const ValidUntilTime = styled('span', ({ $theme }) => ({
    fontWeight: 700
}))

export const ValidUntilP = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: 0,
    marginBottom: $theme.sizing.scale800
}))
